import { Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';

import { ProcessTaskAssignEnum } from '@thinknet-gmbh/platform-common';
import { useGetCurrentAccount } from 'src/hooks/accounts/get-current-account.hook';
import { TaskEditForm } from 'src/pages/tasks-manager/sub-pages/task-list/components/change-task/components/task-edit-form';
import { TaskForm } from 'src/pages/tasks-manager/sub-pages/task-list/components/change-task/components/task-form';

import { IProcessTemplateItemTask } from '../../../../../process-templates-table/process-templates-table.interfaces';

const ChangeTemplateTask = ({
  task,
  onClose,
  onUpdateTask,
  onCreateTask,
}: {
  task: IProcessTemplateItemTask | null;
  onClose: () => void;
  onCreateTask: (task: IProcessTemplateItemTask) => void;
  onUpdateTask: (task: IProcessTemplateItemTask) => void;
}) => {

  const { account } = useGetCurrentAccount();

  return (
    <Fragment>
      {!isEmpty(task) ? (
        <TaskEditForm
          onCancel={onClose}
          onSubmit={onUpdateTask}
          initialValue={task}
          accountId={account._id}
          isProcessTaskTemplate
        />
      ) : (
        <TaskForm
          initialValue={{
            assignTo: ProcessTaskAssignEnum.PERSONS,
            createdBy: account?._id,
          }}
          onCancel={onClose}
          onSubmit={onCreateTask}
          isProcessTaskTemplate
        />
      )}
    </Fragment>
  );
};

export default ChangeTemplateTask;
